/* Common Imports */

import React from "react";

/* Component Imports */

import Layout from "../components/layout-components/Layout";
import PrivacyContent from "../components/page-sections/privacyAndPolicy/PrivacyAndPolicy";

/* Session Imports */
import { withIronSessionSsr } from "iron-session/next";
import { sessionOptions } from "../lib/session";

const PrivacyPolicy = ({ user }) => {
  return (
    <React.Fragment>
      <Layout
        title="Privacy Policy | Sentient Developers – Your Data Matters"
        description="Read how Sentient Developers safeguards your privacy. Learn what data we collect, how it’s used, and your rights in our transparent data protection policy."
        user={user}
      >
        <PrivacyContent />
      </Layout>
    </React.Fragment>
  );
};

export default PrivacyPolicy;

// eslint-disable-next-line space-before-function-paren
export const getServerSideProps = withIronSessionSsr(async function ({ req, res }) {
  /* Getting user session cookie */
  const user = await req.session.user;

  /* User Authorization */
  if (user == undefined) {
    return {
      props: {
        user: { isLoggedIn: false },
      },
    };
  } else {
    /* Pass data to the page via props */
    return {
      props: { user: req.session.user },
    };
  }
}, sessionOptions);
